/** Derive a human-readable title from a video filename. */
export function titleFromFileName(fileName: string): string {
  const base = fileName.replace(/^.*[/\\]/, "").trim();
  const dot = base.lastIndexOf(".");
  const stem = dot > 0 ? base.slice(0, dot) : base;
  return stem
    .replace(/[._-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}
